import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorTemplateGraphLatestQueryVariables = Types.Exact<{
  templateLegacyId: Types.Scalars['Int']['input'];
}>;


export type ConfiguratorTemplateGraphLatestQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', latestRevision?: { __typename: 'ConfiguratorTemplateRevision', graph?: any | null } | null } | null };

export type ConfiguratorTemplateGraphByRevisionQueryVariables = Types.Exact<{
  templateLegacyId: Types.Scalars['Int']['input'];
  revisionLegacyId: Types.Scalars['Int']['input'];
}>;


export type ConfiguratorTemplateGraphByRevisionQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', revision?: { __typename: 'ConfiguratorTemplateRevision', graph?: any | null } | null } | null };

export const ConfiguratorTemplateGraphLatestDocument = gql`
    query configuratorTemplateGraphLatest($templateLegacyId: Int!) {
  configuratorData(templateLegacyId: $templateLegacyId) {
    latestRevision {
      graph
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorTemplateGraphLatestGQL extends Apollo.Query<ConfiguratorTemplateGraphLatestQuery, ConfiguratorTemplateGraphLatestQueryVariables> {
    override document = ConfiguratorTemplateGraphLatestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorTemplateGraphByRevisionDocument = gql`
    query configuratorTemplateGraphByRevision($templateLegacyId: Int!, $revisionLegacyId: Int!) {
  configuratorData(templateLegacyId: $templateLegacyId) {
    revision(legacyId: $revisionLegacyId) {
      graph
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorTemplateGraphByRevisionGQL extends Apollo.Query<ConfiguratorTemplateGraphByRevisionQuery, ConfiguratorTemplateGraphByRevisionQueryVariables> {
    override document = ConfiguratorTemplateGraphByRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }